/**
 * Variantes responsivas geradas no backend para cada upload:
 *   thumb (320px) / card (800px) / full (1600px), sempre WebP.
 * URLs otimizadas seguem o padrão /api/files/.../NOME__full.webp.
 * URLs externas (ex.: Unsplash, que já tem CDN próprio) passam sem alteração.
 */
const VARIANT_RE = /__(thumb|card|full)\.webp$/;

export const isOptimizable = (url) =>
  typeof url === "string" && url.startsWith("/api/files/") && VARIANT_RE.test(url);

export const imgVariant = (url, size = "card") =>
  isOptimizable(url) ? url.replace(VARIANT_RE, `__${size}.webp`) : url;

/** srcset com os 3 tamanhos (só para imagens otimizadas; senão undefined). */
export const imgSrcSet = (url) => {
  if (!isOptimizable(url)) return undefined;
  const base = url.replace(VARIANT_RE, "");
  return `${base}__thumb.webp 320w, ${base}__card.webp 800w, ${base}__full.webp 1600w`;
};

/** Pré-carrega uma imagem (usado para troca instantânea de cor/galeria). */
export const preloadImage = (url, size = "full") => {
  const src = imgVariant(url, size);
  if (!src) return;
  const im = new Image();
  im.src = src;
};

/** srcset responsivo para URLs externas com CDN de redimensionamento (ex.: Unsplash aceita ?w=). */
export const extSrcSet = (url) => {
  if (typeof url !== "string" || !url.includes("images.unsplash.com")) return undefined;
  try {
    const sized = (w) => {
      const u = new URL(url);
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", "72");
      return `${u.toString()} ${w}w`;
    };
    return [480, 768, 1200, 1600].map(sized).join(", ");
  } catch {
    return undefined;
  }
};

/** srcset completo: variantes locais WebP ou redimensionamento do CDN externo. */
export const bannerSrcSet = (url) => imgSrcSet(url) || extSrcSet(url);
